import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "nexus_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const api = axios.create({
  baseURL: API,
  timeout: 60000,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const authApi = {
  me: () => api.get("/auth/me").then((r) => r.data),
  login: (email, password) => api.post("/auth/login", { email, password }).then((r) => r.data),
  register: (email, password, name) => api.post("/auth/register", { email, password, name }).then((r) => r.data),
  logout: () => api.post("/auth/logout").then((r) => r.data),
  session: (sessionId) => api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } }).then((r) => r.data),
  changePassword: (old_password, new_password) =>
    api.post("/auth/change-password", { old_password, new_password }).then((r) => r.data),
};

export const usersApi = {
  list: (status) => api.get("/users", { params: status ? { status } : {} }).then((r) => r.data),
  invite: (email, name, role) => api.post("/users/invite", { email, name, role }).then((r) => r.data),
  approve: (userId, role) => api.post(`/users/${userId}/approve`, { role }).then((r) => r.data),
  setRole: (userId, role) => api.put(`/users/${userId}/role`, { role }).then((r) => r.data),
  resetPassword: (userId) => api.post(`/users/${userId}/reset-password`).then((r) => r.data),
  remove: (userId) => api.delete(`/users/${userId}`).then((r) => r.data),
};

// Normalize a FastAPI error `detail` (string OR 422 validation array) into a display string.
export const formatApiError = (err, fallback = "Something went wrong. Please try again.") => {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export const INTENT_COLORS = {
  "api-payment": "#9D4EDD",
  "data-purchase": "#00F0FF",
  "compute-lease": "#9D4EDD",
  "service-fee": "#00F0FF",
  tip: "#00F0FF",
  collusion: "#FF3366",
  drain: "#FF3366",
  "model-inference": "#9D4EDD",
  orchestration: "#FFB000",
  "stablecoin-settle": "#00F0FF",
};

export const STATUS_COLORS = {
  normal: "#00F0FF",
  watch: "#FFB000",
  critical: "#FF3366",
};

export const fmtUsd = (n) => {
  if (n == null) return "—";
  if (n >= 1e9) return `$${(n / 1e9).toFixed(2)}B`;
  if (n >= 1e6) return `$${(n / 1e6).toFixed(2)}M`;
  if (n >= 1e3) return `$${(n / 1e3).toFixed(2)}K`;
  if (n >= 1) return `$${n.toFixed(2)}`;
  return `$${n.toFixed(4)}`;
};

export const fmtTimeAgo = (iso) => {
  const d = new Date(iso);
  const s = Math.max(1, Math.floor((Date.now() - d.getTime()) / 1000));
  if (s < 60) return `${s}s`;
  if (s < 3600) return `${Math.floor(s / 60)}m`;
  if (s < 86400) return `${Math.floor(s / 3600)}h`;
  return `${Math.floor(s / 86400)}d`;
};
